// Course families share a solution method, while archived tasks keep their IDs.
const SYSTEM_GROUPS = [
  ["MaturaBasic_TwoOrchardsPercentLossSystemSelection", "MaturaBasic_RetailMarkupLinearSystemModel", "MaturaBasic_TreesSystemModel"],
  ["MaturaPercentLinearSystemOpenTask", "MaturaPercentLinearSystemBusinessOpenTask", "MaturaTicketRevenueSystemOpenTask"],
  ["MaturaTextLinearSystemOpenTask", "MaturaBasic_shopping-two-linear-equations-price"],
  ["MaturaBasic_TwoLinearEquationsSolutionPair", "MaturaBasic_SymmetricLinearSystemSignsTruth"],
  ["MaturaBasic_CoordinatePointChooseTwoLineEquations", "MaturaBasic_LinearSystemCoefficientProduct"],
  ["MaturaBasic_TwoLinesGraphChooseSystem", "MaturaBasic_LinearSystemGraphSelection"],
];
const QUADRATIC_GROUPS = [
  ["MaturaFactoredQuadraticInequalityOpenTask", "MaturaBasic_quadratic-inequality-negative-between-fractional-roots",
   "MaturaBasic_ExpandedProductQuadraticClosedInterval", "MaturaBasic_QuadraticInequalityProductVersusLinear"],
];
const POLYNOMIAL_OPERATION_GROUPS = [
  ["MaturaBasic_PolynomialGivenLinearFactorParameter", "MaturaBasic_SumPolynomialCoefficientsUsingValueOne"],
];
const SPECIAL_PRODUCT_GROUPS = [
  // Squaring both binomials and subtracting, or applying A²-B² directly.
  ["MaturaDifferenceSquaresClosedTask", "MaturaBasic_SymbolicConjugateBinomialSquaresDifference",
   "MaturaBasic_ConjugateBinomialSquaresConstantDifference", "MaturaBasic_difference-of-two-symmetric-squares",
   "MaturaBinomialDifferencePolynomialClosedTask"],
];
const equalGeneratorTypes=new Set([...SYSTEM_GROUPS,...QUADRATIC_GROUPS,...POLYNOMIAL_OPERATION_GROUPS,...SPECIAL_PRODUCT_GROUPS].flat());
export const usesEqualBasicCourseGeneratorWeights=type=>equalGeneratorTypes.has(type);
const GROUPS = [
  ...SYSTEM_GROUPS,
  ...QUADRATIC_GROUPS,
  ...POLYNOMIAL_OPERATION_GROUPS,
  ...SPECIAL_PRODUCT_GROUPS,
  // Keep the requested answer format distinct: interval / graph / integer / count.
  ["MaturaLinearInequalityClosedTask", "MaturaBasic_FractionOfDecreasingLinearNumeratorNonStrictInterval",
   "MaturaBasic_FractionalLinearInequalityChooseInterval", "MaturaBasic_NegativeLinearInequalityFractionRight"],
  ["MaturaLinearExtremeInequalityClosedTask", "MaturaBasic_smallest-integer-linear-inequality",
   "MaturaBasic_LinearFractionInequalityGreatestInteger"],
  // Same three-point open method; the interval selects either root.
  ["MaturaRationalIntervalOpenTask", "MaturaBasic_RationalQuadraticRestrictedRoot"],
  ["MaturaRationalExpressionClosedTask", "MaturaBasic_SquareFractionProductCancellation",
   "MaturaBasic_RationalProductDifferenceSquaresCancellation", "MaturaBasic_RationalProductSquaredDenominatorCancellation",
   "MaturaBasic_RationalQuadraticLinearProductCancellation"],
  ["MaturaBasic_division-of-factored-rational-expressions", "MaturaBasic_RationalExpressionDivisionFactoring"],
  ["MaturaBasic_ReciprocalMinusVariableCommonDenominator", "MaturaBasic_SymmetricReciprocalFractionSum"],
  ["MaturaBasic_ThreeLinearNumeratorFactorsRationalZeros", "MaturaBasic_LinearNumeratorFactoredQuadraticDenominatorZero",
   "MaturaBasic_RationalQuadraticTimesPositiveQuadraticZeroCount"],
  ["MaturaBasic_RationalCubicNumeratorDifferenceSquaresDenominator", "MaturaBasic_RationalZeroAllNumeratorRootsExcluded",
   "MaturaBasic_RationalZeroCountCancelledNumeratorRoot"],
  ["MaturaLogPropClosedTask", "MaturaBasic_same-base-log-product-quotient"],
  ["MaturaBasic_LogarithmOfRootPower", "MaturaBasic_LogarithmRootOfBaseRoot", "MaturaBasic_LogarithmSquareRootBaseOfPower"],
  [
    "MaturaAbsoluteValueEquationClosedTask",
    "MaturaBasic_AbsoluteEquationTwoRootSum",
  ],
  [
    "MaturaBasic_SameBasePowerQuotient",
    "MaturaBasic_ThreePowerBasesProductQuotient",
    "MaturaPowerDivisionClosedTask",
    "MaturaBasic_ReciprocalPowerTimesPowerCommonBase",
  ],
  [
    "MaturaNestedRootPowerClosedTask",
    "MaturaBasic_RootReciprocalNegativePower",
    "MaturaBasic_DecimalFractionPowerProductRoot",
    "MaturaBasic_PowerTimesSquareRootCubeRoot",
  ],
  [
    "MaturaBasic_CubeRootsProductQuotient",
    "MaturaBasic_CubeRootNegativeFractionProduct",
  ],
  [
    "MaturaPowerTimesRootClosedTask",
    "MaturaBasic_IntegerPowerTimesRationalPowerCommonBase",
  ],
].map(group => Object.freeze(group));

const groupsByType = new Map(GROUPS.flatMap(group => group.map(type => [type, group])));

export const getBasicCourseGroupTypes = type => groupsByType.get(type) || [type];
export const getBasicCourseGroupType = type => getBasicCourseGroupTypes(type)[0];
export const isBasicCourseGroup = type => groupsByType.has(type);

export function groupBasicCourseTypes(types) {
  return [...new Set(types.map(getBasicCourseGroupType))];
}
